import DashboardNavbar from "../../../Components/Navbars/DashboardNavbar";
import DashboardLayout from "../../../Components/LayoutContainers/DashboardLayout";
import {setLoading, useMaterialUIController} from "../../../Context/mui";
import React, {useEffect, useLayoutEffect, useMemo, useState} from "react";
import {useFormik} from "formik";
import MDBox from "../../../Components/MDBox";
import {ButtonBase, Grid} from "@mui/material";
import MDInput from "../../../Components/MDInput";
import MDSelect from "../../../Components/MDSelect";
import MDDate from "../../../Components/MDDate";
import MDTypography from "../../../Components/MDTypography";
import Icon from "@mui/material/Icon";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import IconButton from "@mui/material/IconButton";
import {v4 as uuid} from 'uuid'
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import * as yup from 'yup';
import Cookies from "js-cookie";
import {ErrorToaast, SuccessToaast} from "../../..//utils/toast/Toast";
import {StudentSalamatModel} from "../../../Api/Model/SalamatModel";
import HeroLayout from "../../../Components/LayoutContainers/HeroLayout";
import EsBan from "../../../Asset/images/esban.png"
import EsB1 from "../../../Asset/images/Esb1.png"
import EsB2 from "../../../Asset/images/Esb2.png"
import EsB3 from "../../../Asset/images/Esb3.png"
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton'
import EsB4 from "../../../Asset/images/Esb4.png"
import SMAImage from "../../../Asset/images/salamatmaleactor.png"
import SFAImage from "../../../Asset/images/salamatfmaleactor.png"
import Divider from "@mui/material/Divider";
import {CurrentUser} from "../../../utils/Hooks/currentUser";
import {useNavigate} from "react-router-dom";


const validationSchema = yup.object({

    Vaksan: yup.array().of(
        yup.object({
            id: yup.string().required(),
            VaksanKind: yup.string().required('نوع واکسن الزامی است'),
            VaksanDate: yup.date().required('تاریخ واکسن الزامی است'),
            VaksanAvarez: yup.string()
        })
    ),
    Daroo: yup.array().of(
        yup.object({
            id: yup.string().required(),
            DarooName: yup.string().required('نام دارو الزامی است'),
            DarooZaman: yup.string().required('زمان مصرف دارو الزامی است'),
            DarooGhat: yup.string().required('دلیل قطع مصرف دارو الزامی است'),
            DarooDoz: yup.string().required('دوز و تعداد دارو الزامی است')
        })
    ),
    Height: yup.number().required('قد الزامی است'),
    Weight: yup.number().required('وزن الزامی است'),
    Bmi: yup.number().required('شاخص توده بدنی الزامی است'),
    AzmayeshName: yup.string(),
    AzmayeshDate: yup.date(),
    AzmayeshResult: yup.string(),
    AzmayeshDalil: yup.string(),
    AzmayeshTafsir: yup.string(),
    AzmayeshAlt: yup.number(),
    AzmayeshAST: yup.number(),
    AzmayeshGGT: yup.number(),
    PrevBimary: yup.string(),
    Hasasiat: yup.string(),
    Hdl: yup.number(),
    Triglycerides: yup.number(),
    TCholestrol: yup.number(),
    Lholestrol: yup.number(),
    BimaryHistory: yup.string()
});
const steps = [
    'اطلاعات کلی',
    'آزمایشات',
    'واکسیناسیون',
    'دارو های مصرفی'
];

export default function SalamatStudent() {
    const [activeStep, setActiveStep] = React.useState(null);
    const [miniStep, setMiniStep] = React.useState(0);
    const navigate = useNavigate();
    const [controller, dispatch] = useMaterialUIController();
    const [isNew, setIsnew] = useState(true)
    var Api = new StudentSalamatModel(Cookies.get("cst") ?? "");
    const {loading} = controller;
    const formik = useFormik({
        initialValues: {

            Vaksan: [],
            Daroo: [],
            Height: "",
            Weight: "",
            Bmi: "",
            AzmayeshName: "",
            AzmayeshDate: "",
            AzmayeshResult: "",
            AzmayeshDalil: "",
            AzmayeshTafsir: "",
            AzmayeshAlt: "",
            AzmayeshAST: "",
            AzmayeshGGT: "",
            PrevBimary: "",
            Hasasiat: "",
            Hdl: "",
            Triglycerides: "",
            TCholestrol: "",
            Lholestrol: "",
            BimaryHistory: ""
        },
        validationSchema: validationSchema,

        onSubmit: (values) => {

            Api.Create({

                Vaksan: values.Vaksan,
                Daroo: values.Daroo,
                Height: values.Height,
                Weight: values.Weight,
                Bmi: values.Bmi,
                AzmayeshName: values.AzmayeshName,
                AzmayeshDate: values.AzmayeshDate,
                AzmayeshResult: values.AzmayeshResult,
                AzmayeshDalil: values.AzmayeshDalil,
                AzmayeshTafsir: values.AzmayeshTafsir,
                AzmayeshAlt: values.AzmayeshAlt,
                AzmayeshAST: values.AzmayeshAST,
                AzmayeshGGT: values.AzmayeshGGT,
                PrevBimary: values.PrevBimary,
                Hasasiat: values.Hasasiat,
                Hdl: values.Hdl,
                Triglycerides: values.Triglycerides,
                TCholestrol: values.TCholestrol,
                Lholestrol: values.Lholestrol,
                BimaryHistory: values.BimaryHistory,
            }).then(response => {
                setLoading(dispatch, false)


                handleChangeMStep()
                SuccessToaast("با موفقیت ویرایش شد")
            })
                .catch(error => {
                    ErrorToaast("خطا در ثبت اطلاعات");
                    setLoading(dispatch, false);
                });


        }
    })

    function addVaksan() {
        formik.setFieldValue("Vaksan", [...formik.values.Vaksan, {
            id: uuid(),
            VaksanKind: "",
            VaksanDate: "",
            VaksanAvarez: ""
        }])

    }

    function addDaroo() {
        formik.setFieldValue("Daroo", [...formik.values.Daroo, {
            id: uuid(),
            DarooName: "",
            DarooZaman: "",
            DarooGhat: "",
            DarooDoz: ""
        }])
    }

    useLayoutEffect(() => {
        setLoading(dispatch, true)
        Api.Get()
            .then(r => {
                if (r.data.data !== null) {
                    setIsnew(false)
                    let model = r.data.data;
                    formik.setValues({
                        Vaksan: model.vaksan.map(p => ({
                            id: p.id,
                            VaksanKind: p.vaksanKind,
                            VaksanDate: p.vaksanDate,
                            VaksanAvarez: p.vaksanAvarez
                        }),),
                        Daroo: model.daroo.map(p => ({
                            id: p.id,
                            DarooName: p.darooName,
                            DarooZaman: p.darooZaman,
                            DarooGhat: p.darooGhat,
                            DarooDoz: p.darooDoz,
                        }),),
                        Height: model.height,
                        Weight: model.weight,
                        Bmi: model.bmi,
                        AzmayeshName: model.azmayeshName,
                        AzmayeshDate: model.azmayeshDate,
                        AzmayeshResult: model.azmayeshResult,
                        AzmayeshDalil: model.azmayeshDalil,
                        AzmayeshTafsir: model.azmayeshTafsir,
                        AzmayeshAlt: model.azmayeshAlt,
                        AzmayeshAST: model.azmayeshAST,
                        AzmayeshGGT: model.azmayeshGGT,
                        PrevBimary: model.prevBimary,
                        Hasasiat: model.hasasiat,
                        Hdl: model.hdl,
                        Triglycerides: model.triglycerides,
                        TCholestrol: model.tCholestrol,
                        Lholestrol: model.lholestrol,
                        BimaryHistory: model.bimaryHistory

                    })
                }
                setLoading(dispatch, false)
            })
            .catch(r => {
                if (r?.status == 404) {
                    setLoading(dispatch, false)

                    return
                }
                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })

    }, [])
    useEffect(() => {
        let Bmi = formik.values.Weight / ((formik.values.Height / 100) * (formik.values.Height / 100))
        if (typeof Bmi == "number" && !isNaN(Bmi)) {
            formik.setFieldValue("Bmi", Bmi.toFixed(2))
        } else {
            formik.setFieldValue("Bmi", "0")
        }
    }, [formik.values.Height, formik.values.Weight])
    const calculatedValue = useMemo(() => {
        const bmi = parseFloat(formik?.values?.Bmi);

        if (isNaN(bmi)) {
            return {color: "#ccc", status: "بی‌ام‌آی نامعتبر"}; // Invalid BMI
        }

        if (bmi < 18.5) {
            return {color: "#1e90ff", status: "کم‌وزن"}; // Underweight
        } else if (bmi >= 18.5 && bmi < 24.9) {
            return {color: "#32cd32", status: "وزن نرمال"}; // Normal weight
        } else if (bmi >= 25 && bmi < 29.9) {
            return {color: "#ffa500", status: "اضافه وزن"}; // Overweight
        } else if (bmi >= 30 && bmi < 34.9) {
            return {color: "#ff4500", status: "چاقی (کلاس ۱)"}; // Obesity (Class 1)
        } else if (bmi >= 35 && bmi < 39.9) {
            return {color: "#ff0000", status: "چاقی (کلاس ۲)"}; // Obesity (Class 2)
        } else if (bmi >= 40) {
            return {color: "#8b0000", status: "چاقی مفرط (کلاس ۳)"}; // Extreme obesity (Class 3)
        }

        return {color: "#000000", status: "نا مشخص"}; // Fallback
    }, [formik?.values?.Bmi]);

    const totalSteps = () => {
        return steps.length;
    };
    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const handleNext = () => {
        setActiveStep(newActiveStep);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleStep = (step) => () => {
        setActiveStep(step);
        switch (step) {
            case 0:
                setMiniStep(0)
                break;
            case 1:
                setMiniStep(4)
                break;
            case 2:
                setMiniStep(8)
                break;
            case 3:
                setMiniStep(10)
                break;
        }
    };

    function handleNextStep() {

        formik.handleSubmit()
    }

    function handleChangeMStep() {
        if (miniStep === 11) {
            setActiveStep(null)
            setMiniStep(0)

            return;
        }
        if ([3, 7, 9].includes(miniStep)) {
            setActiveStep(c => c + 1)

        }
        setMiniStep(c => c + 1)
    }

    function handleBazgasht() {
        setMiniStep(0)
        setActiveStep(null)
    }

    return <HeroLayout Showdesc={![3, 7, 9, 11].includes(miniStep)}>
        {![3, 7, 9, 11].includes(miniStep) ? <>

            <MDBox mx={{xs: 2, md: 10, xl: 10}} mt={4} component="form" role="form" onSubmit={formik.handleSubmit}>
                <MDBox sx={{justifySelf: "center"}}>
                    <img src={EsBan} style={{height: "15vh", width: "100%"}}/>
                </MDBox>
                {activeStep == null && <>

                    <MDBox sx={{justifySelf: "center"}} pb={5}>
                        <Grid container textAlign={"center"} gap={5} mt={5}>
                            <Grid item xs={12} sx={{cursor: "pointer"}}
                                  onClick={() => setActiveStep(0) && setMiniStep(0)}>
                                <MDBox component={"img"} src={EsB1}
                                       sx={{height: "30vh", width: {xs: "100%", md: "100%", xl: "unset"}}}/>
                            </Grid>
                            <Grid item xs={12} sx={{cursor: "pointer"}}
                                  onClick={() => (setActiveStep(1) & setMiniStep(4))}>
                                <MDBox component={"img"} src={EsB2}
                                       sx={{height: "30vh", width: {xs: "100%", md: "100%", xl: "unset"}}}/>
                            </Grid>
                            <Grid item xs={12} sx={{cursor: "pointer"}}
                                  onClick={() => (setActiveStep(2) & setMiniStep(8))}>
                                <MDBox component={"img"} src={EsB3}
                                       sx={{height: "30vh", width: {xs: "100%", md: "100%", xl: "unset"}}}/>
                            </Grid>
                            <Grid item xs={12} sx={{cursor: "pointer"}}
                                  onClick={() => (setActiveStep(3) & setMiniStep(10))}>
                                <MDBox component={"img"} src={EsB4}
                                       sx={{height: "30vh", width: {xs: "100%", md: "100%", xl: "unset"}}}/>
                            </Grid>
                            <Grid item xs={12} sx={{cursor: "pointer"}}
                                  onClick={() => navigate("/studentlanding")}>
                                <MDTypography sx={{fontSize: "40px"}}>بازگشت</MDTypography>
                            </Grid>
                        </Grid>

                    </MDBox>
                </>
                }
                <MDTypography sx={{
                    justifySelf: "center",
                    fontSize: "2rem",
                    color: "#005CB1",
                    fontFamily: "lale",
                    fontWeight: "bold"
                }}>
                    {steps[activeStep]}
                </MDTypography>
                {activeStep != null && <>
                    {formik?.values?.Bmi && parseInt(formik?.values.Bmi) > 1 && (
                        <MDBox py={3} bgColor="radial-gradient(circle, #55b2fa, #46a4f4, #3a96ed, #3188e5, #2d79dd)"
                               border={"1px solid darkblue"} p={1} mb={2} flex={1} borderRadius={2}
                               style={{overflowX: "auto", borderRadius: "10px", display: "flex", alignItems: "center"}}>

                            <svg width="40" height="40" viewBox="0 0 102 101" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M50.8281 6.3125C62.5474 6.3125 73.7866 10.968 82.0734 19.2547C90.3602 27.5415 95.0156 38.7807 95.0156 50.5C95.0156 62.2193 90.3602 73.4585 82.0734 81.7453C73.7866 90.032 62.5474 94.6875 50.8281 94.6875C39.1089 94.6875 27.8696 90.032 19.5828 81.7453C11.2961 73.4585 6.64063 62.2193 6.64062 50.5C6.64062 38.7807 11.2961 27.5415 19.5828 19.2547C27.8696 10.968 39.1089 6.3125 50.8281 6.3125ZM50.8281 25.25C50.0267 25.2493 49.2339 25.4157 48.5004 25.7387C47.7669 26.0617 47.1089 26.5341 46.5683 27.1258C46.0277 27.7175 45.6165 28.4154 45.3609 29.175C45.1052 29.9346 45.0109 30.7391 45.0838 31.5372L47.3878 56.8251C47.4771 57.6753 47.8781 58.4623 48.5134 59.0343C49.1487 59.6064 49.9733 59.9229 50.8281 59.9229C51.683 59.9229 52.5076 59.6064 53.1429 59.0343C53.7781 58.4623 54.1791 57.6753 54.2684 56.8251L56.5662 31.5372C56.639 30.7397 56.5448 29.9356 56.2896 29.1765C56.0343 28.4173 55.6237 27.7197 55.0838 27.1281C54.5439 26.5366 53.8866 26.064 53.1539 25.7406C52.4211 25.4173 51.629 25.2502 50.8281 25.25ZM50.8281 75.75C52.1675 75.75 53.452 75.2179 54.399 74.2709C55.3461 73.3238 55.8781 72.0393 55.8781 70.7C55.8781 69.3607 55.3461 68.0762 54.399 67.1291C53.452 66.1821 52.1675 65.65 50.8281 65.65C49.4888 65.65 48.2043 66.1821 47.2572 67.1291C46.3102 68.0762 45.7781 69.3607 45.7781 70.7C45.7781 72.0393 46.3102 73.3238 47.2572 74.2709C48.2043 75.2179 49.4888 75.75 50.8281 75.75Z"
                                    fill="#FBBC04"/>
                            </svg>

                            <MDTypography fontWeight={"bold"} color={"white"} sx={{mx: 2}}>
                                وضعیت bmi شما با توجه به وزن و قد <span
                                style={{color: "White"}}> {calculatedValue.status}</span> می باشد
                            </MDTypography>
                        </MDBox>
                    )}
                    <MDBox sx={{
                        width: {xs: "100%", md: "100%", xl: "50%"},
                        minHeight: "50vh",
                        justifySelf: "center",
                        background: "white",
                        border: "1px solid #00000073",
                        borderRadius: "10px",
                        px: {xs: 1, md: 1, xl: 10},
                        py: 5
                    }}>
                        <Grid container spacing={10}>
                            {miniStep === 0 && <>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="Height"
                                        name="Height"
                                        value={formik.values.Height}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Height)
                                        }
                                        helperText={formik.errors.Height}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        sx={{width: "100%"}}

                                        label={"قد"}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="Weight"
                                        name="Weight"
                                        value={formik.values.Weight}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Weight)
                                        }
                                        helperText={formik.errors.Weight}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        sx={{width: "100%"}}

                                        label={"وزن"}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="Bmi"
                                        name="Bmi"
                                        value={formik.values.Bmi}
                                        onChange={() => {
                                        }}
                                        error={
                                            Boolean(formik.errors.Bmi)
                                        }
                                        helperText={formik.errors.Bmi}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        sx={{width: "100%"}}
                                        label={"شاخص توده بدنی (bmi)"}/>
                                </Grid>

                            </>}
                            {miniStep === 1 && <>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="BimaryHistory"
                                        name="BimaryHistory"
                                        value={formik.values.BimaryHistory}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.BimaryHistory)
                                        }
                                        helperText={formik.errors.BimaryHistory}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        // width={"200px"}
                                        sx={{width: "100%"}}
                                        label={"توضیحات سوابق بستری"}/>
                                </Grid>
                            </>}
                            {miniStep === 2 && <>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="PrevBimary"
                                        name="PrevBimary"
                                        value={formik.values.PrevBimary}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.PrevBimary)
                                        }
                                        helperText={formik.errors.PrevBimary}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        // width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"بیماری های قبلی"}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="Hasasiat"
                                        name="Hasasiat"
                                        value={formik.values.Hasasiat}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Hasasiat)
                                        }
                                        helperText={formik.errors.Hasasiat}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        // width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"حساسیت ها"}/>
                                </Grid>
                            </>}
                            {miniStep === 4 && <>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="AzmayeshName"
                                        name="AzmayeshName"
                                        value={formik.values.AzmayeshName}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.AzmayeshName)
                                        }
                                        helperText={formik.errors.AzmayeshName}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        // width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"نوع آزمایش"}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <MDDate
                                        name="AzmayeshDate"
                                        onChange={(r) =>
                                            formik.setFieldValue("AzmayeshDate", r)
                                        }
                                        defaultValue={formik.values.AzmayeshDate}
                                        label={("تاریخ آزمایش")}
                                        error={
                                            Boolean(formik.errors.AzmayeshDate)
                                        }
                                        portal
                                        helperText={
                                            formik.errors.AzmayeshDate
                                        }
                                        w={{xs: "100%", md: "100%", lg: "100%",}}

                                        disabled={loading}
                                    />
                                </Grid> <Grid item xs={12}>
                                <MDInput
                                    id="AzmayeshResult"
                                    name="AzmayeshResult"
                                    value={formik.values.AzmayeshResult}
                                    onChange={formik.handleChange}
                                    error={
                                        Boolean(formik.errors.AzmayeshResult)
                                    }
                                    helperText={formik.errors.AzmayeshResult}
                                    autoComplete={"1"}
                                    disabled={loading}
                                    // width={"200px"}
                                    sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                    label={"نتیجه آزمایش"}/>
                            </Grid>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="AzmayeshDalil"
                                        name="AzmayeshDalil"
                                        value={formik.values.AzmayeshDalil}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.AzmayeshDalil)
                                        }
                                        helperText={formik.errors.AzmayeshDalil}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        // width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"علت تجویز آزمایش"}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="AzmayeshTafsir"
                                        name="AzmayeshTafsir"
                                        value={formik.values.AzmayeshTafsir}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.AzmayeshTafsir)
                                        }
                                        helperText={formik.errors.AzmayeshTafsir}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        // width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"تفسیر آزمایش"}/>
                                </Grid>

                            </>}
                            {miniStep === 5 && <>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="AzmayeshAlt"
                                        name="AzmayeshAlt"
                                        value={formik.values.AzmayeshAlt}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.AzmayeshAlt)
                                        }
                                        helperText={formik.errors.AzmayeshAlt}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        //  width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"ALT"}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="AzmayeshAST"
                                        name="AzmayeshAST"
                                        value={formik.values.AzmayeshAST}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.AzmayeshAST)
                                        }
                                        helperText={formik.errors.AzmayeshAST}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        //  width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"AST"}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="AzmayeshGGT"
                                        name="AzmayeshGGT"
                                        value={formik.values.AzmayeshGGT}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.AzmayeshGGT)
                                        }
                                        helperText={formik.errors.AzmayeshGGT}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        //  width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"GGT"}/>
                                </Grid>

                            </>}
                            {miniStep === 6 && <>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="Hdl"
                                        name="Hdl"
                                        value={formik.values.Hdl}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Hdl)
                                        }
                                        helperText={formik.errors.Hdl}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        // width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"HDL"}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="Triglycerides"
                                        name="Triglycerides"
                                        value={formik.values.Triglycerides}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Triglycerides)
                                        }
                                        helperText={formik.errors.Triglycerides}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        // width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"Triglycerides"}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="TCholestrol"
                                        name="TCholestrol"
                                        value={formik.values.TCholestrol}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.TCholestrol)
                                        }
                                        helperText={formik.errors.TCholestrol}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        // width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"Total cholestrol"}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <MDInput
                                        id="Lholestrol"
                                        name="Lholestrol"
                                        value={formik.values.Lholestrol}
                                        onChange={formik.handleChange}
                                        error={
                                            Boolean(formik.errors.Lholestrol)
                                        }
                                        helperText={formik.errors.Lholestrol}
                                        autoComplete={"1"}
                                        disabled={loading}
                                        // width={"200px"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                        label={"LDL cholestrol"}/>
                                </Grid>
                            </>}
                            {miniStep === 8 && <>
                                <Grid container justifyItems={"center"} alignItems={"center"} item xs={12}>
                                    <MDTypography fontWeight={"bold"}>
                                        تاریخچه واکسیناسیون
                                    </MDTypography>
                                    <IconButton color={"info"} onClick={() => addVaksan()}>
                                        <AddCircleOutlineOutlinedIcon/>
                                    </IconButton>
                                </Grid>
                                {formik.values.Vaksan && formik.values.Vaksan.length > 0 && formik.values.Vaksan.map((e, i) => {
                                    return (
                                        <React.Fragment key={e.id}>
                                            <Grid item xs={12}>
                                                <MDInput
                                                    id={`Vaksan.${i}.VaksanKind`}
                                                    name={`Vaksan.${i}.VaksanKind`}
                                                    value={formik.values.Vaksan[i].VaksanKind}
                                                    onChange={formik.handleChange}
                                                    error={
                                                        Boolean(formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanKind)
                                                    }
                                                    helperText={formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanKind}
                                                    autoComplete={"1"}
                                                    disabled={loading}
                                                    // width={"200px"}
                                                    sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                                    label={"نوع واکسن "}/>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <MDDate

                                                    name={`Vaksan.${i}.VaksanDate`}
                                                    onChange={(r) =>
                                                        formik.setFieldValue(`Vaksan.${i}.VaksanDate`, r)
                                                    }
                                                    defaultValue={formik.values.Vaksan[i].VaksanDate}
                                                    label={("تاریخ واکسن")}
                                                    error={
                                                        Boolean(formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanDate)
                                                    }
                                                    helperText={formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanDate}
                                                    portal
                                                    w={{xs: "100%", md: "100%", lg: "100%",}}

                                                    disabled={loading}
                                                />
                                            </Grid>
                                            <Grid container item xs={12}>
                                                <MDInput
                                                    id={`Vaksan.${i}.VaksanAvarez`}
                                                    name={`Vaksan.${i}.VaksanAvarez`}
                                                    value={formik.values.Vaksan[i].VaksanAvarez}
                                                    onChange={formik.handleChange}
                                                    error={
                                                        Boolean(formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanAvarez)
                                                    }
                                                    helperText={formik.errors.Vaksan && formik.errors.Vaksan[i] && formik.errors.Vaksan[i].VaksanAvarez}
                                                    autoComplete={"1"}
                                                    disabled={loading}
                                                    // width={"200px"}
                                                    sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                                    label={"عوارض واکسن "}/>
                                                <IconButton color={"error"}
                                                            onClick={() => formik.setFieldValue("Vaksan", formik.values.Vaksan.filter(p => p.id != formik.values.Vaksan[i].id))}>
                                                    <RemoveCircleOutlineOutlinedIcon/>
                                                </IconButton>
                                            </Grid>

                                        </React.Fragment>
                                    )
                                })}
                            </>}
                            {miniStep === 10 && <>
                                <Grid container item gap={2}>
                                    <Grid container justifyItems={"center"} alignItems={"center"} item>
                                        <MDTypography fontWeight={"bold"}>
                                            داروهای مصرفی
                                        </MDTypography>
                                        <IconButton color={"info"} onClick={() => addDaroo()}>
                                            <AddCircleOutlineOutlinedIcon/>
                                        </IconButton>
                                    </Grid>
                                    {formik.values.Daroo && formik.values.Daroo.length > 0 && formik.values.Daroo.map((e, i) => {
                                        return (
                                            <React.Fragment key={e.id}>
                                                <Grid item xs={12}>
                                                    <MDInput
                                                        id={`Daroo.${i}.DarooName`}
                                                        name={`Daroo.${i}.DarooName`}
                                                        value={formik.values.Daroo[i].DarooName}
                                                        onChange={formik.handleChange}
                                                        error={
                                                            Boolean(formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooName)
                                                        }
                                                        helperText={formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooName}
                                                        autoComplete={"1"}
                                                        disabled={loading}
                                                        ///    width={"200px"}
                                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                                        label={"نام دارو"}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <MDInput
                                                        id={`Daroo.${i}.DarooZaman`}
                                                        name={`Daroo.${i}.DarooZaman`}
                                                        value={formik.values.Daroo[i].DarooZaman}
                                                        onChange={formik.handleChange}
                                                        error={
                                                            Boolean(formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooZaman)
                                                        }
                                                        helperText={formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooZaman}
                                                        autoComplete={"1"}
                                                        disabled={loading}
                                                        ///    width={"200px"}
                                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                                        label={"زمان مصرف دارو"}/>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <MDInput
                                                        id={`Daroo.${i}.DarooGhat`}
                                                        name={`Daroo.${i}.DarooGhat`}
                                                        value={formik.values.Daroo[i].DarooGhat}
                                                        onChange={formik.handleChange}
                                                        error={
                                                            Boolean(formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooGhat)
                                                        }
                                                        helperText={formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooGhat}
                                                        autoComplete={"1"}
                                                        disabled={loading}
                                                        ///    width={"200px"}
                                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                                        label={"دلیل قطع مصرف دارو"}/>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <MDInput
                                                        id={`Daroo.${i}.DarooDoz`}
                                                        name={`Daroo.${i}.DarooDoz`}
                                                        value={formik.values.Daroo[i].DarooDoz}
                                                        onChange={formik.handleChange}
                                                        error={
                                                            Boolean(formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooDoz)
                                                        }
                                                        helperText={formik.errors.Daroo && formik.errors.Daroo[i] && formik.errors.Daroo[i].DarooDoz}
                                                        autoComplete={"1"}
                                                        disabled={loading}
                                                        ///    width={"200px"}
                                                        sx={{width: {xs: "100%", md: "100%", lg: "100%",}}}
                                                        label={"دوز  و تعداد دارو"}/>
                                                </Grid>
                                                <IconButton color={"error"}
                                                            onClick={() => formik.setFieldValue("Daroo", formik.values.Daroo.filter(p => p.id != formik.values.Daroo[i].id))}>
                                                    <RemoveCircleOutlineOutlinedIcon/>
                                                </IconButton>

                                            </React.Fragment>
                                        )
                                    })}
                                </Grid>
                            </>}

                            <Grid item xs={12} textAlign={"start"}>
                                <ButtonBase onClick={() => handleNextStep()}
                                            sx={{background: "#0BE1B1", width: "100%", borderRadius: "5px", height: 50}}
                                            disabled={loading}
                                            type={"button"}>
                                    <MDBox width={"100%"} py={2}>
                                        <MDTypography color={"black"} fontWeight={"bold"} fontSize={"20px"}>
                                            مرحله بعد
                                        </MDTypography>
                                    </MDBox>
                                </ButtonBase>

                            </Grid>
                        </Grid>
                    </MDBox>
                    <MDBox sx={{
                        width: "50%",
                        justifySelf: "end",
                        textAlign: "center"
                    }}>
                        <ButtonBase onClick={() => handleBazgasht()}
                                    sx={{borderRadius: "5px", height: 50,}}
                                    disabled={loading}
                                    type={"button"}>
                            <MDTypography color={"black"} fontSize={"25px"} sx={{mr: 10}}>
                                بازگشت
                            </MDTypography>
                        </ButtonBase>
                    </MDBox>

                    <MDBox sx={{
                        py: 5,
                        width: "100%",
                        display: "flex",
                        placeContent: "end",
                        alignItems: "center",
                        flexDirection: {xs: "column", md: "unset", xl: "unset"},
                        position: {xs: "unset", md: "relative", xl: "relative"}
                    }}>
                        <MDBox component={"img"} src={CurrentUser().user.Sex === "F" ? SFAImage : SMAImage}
                               sx={{
                                   height: {xs: "30vh", md: "30vh", xl: "30vh"},
                                   position: {xs: "unset", md: "fixed", xl: "absolute"},
                                   left: 0,
                                   bottom: {xs: "unset", md: "0", xl: "55px"}
                               }}/>
                        <MDBox sx={{width: "100%", border: "1px solid black", position: {xs: "relative", md: "absolute", xl: "absolute"},top:{xs: "20px", md: "unset", xl: "unset"}}}/>
                        <Stepper nonLinear alternativeLabel activeStep={activeStep}
                                 sx={{width: {xs: "100%", xl: "50%"}}}>
                            {steps.map((label, index) => (
                                <Step key={label}>
                                    <StepButton color="inherit" onClick={handleStep(index)}/>

                                </Step>
                            ))}
                        </Stepper>
                    </MDBox>
                </>}

            </MDBox>
        </> : <>
            <Grid container direction={"column"} textAlign={"center"} sx={{py: "4rem"}}>
                <Grid item>
                    <MDTypography sx={{color: "#005CB1", fontSize: "4rem", fontFamily: "vazir", fontWeight: "bold"}}>مرحله
                        تکمیل شد</MDTypography>
                </Grid>
                <Grid item>
                    <img src={CurrentUser().user.Sex === "F" ? SFAImage : SMAImage} style={{height: "60vh"}}/>
                </Grid>
                <Grid item>
                    <MDTypography sx={{color: "#005CB1", fontSize: "4rem", fontFamily: "vazir", fontWeight: "bold"}}>آماده
                        ای برای مرحله بعد؟</MDTypography>

                </Grid>
                <Grid item>
                    <ButtonBase onClick={handleChangeMStep}
                                sx={{background: "#FF4D00", borderRadius: "5px", height: 50, py: 5, px: 10}}
                                disabled={loading}
                                type={"button"}>
                        <MDBox width={"100%"} py={2}>
                            <MDTypography color={"white"} fontWeight={"bold"} fontSize={"50px"}>
                                بزن بریم
                            </MDTypography>
                        </MDBox>
                    </ButtonBase>
                </Grid>
            </Grid>

        </>}
    </HeroLayout>
}